import { gql } from '@apollo/client';

export default gql`
  fragment LandingPageAttachment on Attachment {
    id
    name
    mimeType
    url
    status
    folderPath
  }
`;
